module.exports = __webpack_public_path__ + "img/todo_completed.7c185627.svg";